module.exports = __webpack_public_path__ + "/login_ui/img/ck-e52d733f2496f8f40a2ee6e94d4ad6c9.svg";